import React, { useEffect } from 'react';
import { EMPTY_STATE_ZERO_COMMENTS_CONTENT, EMPTY_STATE_ZERO_COMMENTS_TITLE, } from '../../common/constants/data-hooks';
import { useTranslate } from '../context/api-context/translations/use-translate';
import { useApi } from '../context/api-context/use-api';
import { useConfiguration } from '../context/configuration-context/use-configuration';
import TextExtended from '../components/text-extended/text-extended';
import styles from './zero-comments-empty-state.scss';
const ZeroCommentsEmptyState = () => {
    const t = useTranslate();
    const { resourceId, _debugTranslations } = useConfiguration();
    const { biShowZeroCommentsEmptyState } = useApi((state, actions) => actions);
    useEffect(() => {
        biShowZeroCommentsEmptyState({ resourceId });
    }, []);
    return (React.createElement("div", { className: styles.container },
        React.createElement(TextExtended, { dataHook: EMPTY_STATE_ZERO_COMMENTS_TITLE, className: styles.title, typography: "titleSmall" }, t('empty-state.zero-comments-title')),
        React.createElement(TextExtended, { dataHook: EMPTY_STATE_ZERO_COMMENTS_CONTENT, className: styles.text }, t('empty-state.zero-comments-text')),
        _debugTranslations ? (React.createElement(React.Fragment, null,
            React.createElement("hr", null),
            React.createElement("div", null,
                // @ts-expect-error
                JSON.stringify(t.debug),
                React.createElement("hr", null),
                // @ts-expect-error
                JSON.stringify(t.i18n.store.data)))) : null));
};
export default ZeroCommentsEmptyState;
//# sourceMappingURL=zero-comments-empty-state.js.map